import { render } from "./InvoiceDetailsModal.vue?vue&type=template&id=0c0e90ee"
import script from "./InvoiceDetailsModal.vue?vue&type=script&lang=js"
export * from "./InvoiceDetailsModal.vue?vue&type=script&lang=js"

import "./InvoiceDetailsModal.vue?vue&type=style&index=0&id=0c0e90ee&lang=scss"

import exportComponent from "/home/mon3m/mon3m/dafater/ManageSPA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__